"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var React = __importStar(require("react"));
var react_1 = require("react");
var react_transition_group_1 = require("react-transition-group");
require("./Dropdown.css");
var Icon_1 = require("../icon/Icon");
var Button_1 = require("../button/Button");
var useOnClickOutside_1 = require("../../hooks/useOnClickOutside");
var string_1 = require("../../utils/string");
var useOnTabOutside_1 = require("../../hooks/useOnTabOutside");
var keyboard_1 = require("../../utils/dom/keyboard");
var DropdownTheme;
(function (DropdownTheme) {
    DropdownTheme["basic"] = "basic";
    DropdownTheme["box"] = "box";
    DropdownTheme["none"] = "none";
})(DropdownTheme = exports.DropdownTheme || (exports.DropdownTheme = {}));
var DropdownContext = React.createContext({
    expanded: false,
    isHidden: undefined,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setDropdownClassName: function (className) { },
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setAriaHasPopup: function (label) { },
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setAriaLabel: function (label) { },
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    closeDropdown: function () { },
});
function useDropdownContext() {
    var context = React.useContext(DropdownContext);
    // if (!context) {
    //   throw new Error(
    //     `Dropdown compound components cannot be rendered outside the Dropdown component`
    //   );
    // }
    return context;
}
exports.useDropdownContext = useDropdownContext;
var DropdownComp = function (_a) {
    var _b;
    var _c;
    var buttonProps = _a.buttonProps, props = __rest(_a, ["buttonProps"]);
    var htmlProps = (function (_a) {
        var label = _a.label, expanded = _a.expanded, autoAlign = _a.autoAlign, disabled = _a.disabled, icon = _a.icon, overlay = _a.overlay, dismissOnChange = _a.dismissOnChange, unmountOnExit = _a.unmountOnExit, theme = _a.theme, onOpen = _a.onOpen, onClose = _a.onClose, rest = __rest(_a, ["label", "expanded", "autoAlign", "disabled", "icon", "overlay", "dismissOnChange", "unmountOnExit", "theme", "onOpen", "onClose"]);
        return rest;
    })(props);
    //--- refs ---//
    var el = react_1.useRef(null);
    var onCloseRef = react_1.useRef();
    var toggleRef = react_1.useRef(null);
    var menuRef = react_1.useRef(null);
    var menuId = react_1.useRef(string_1.getRandomString());
    //--- states ---//
    var _d = __read(react_1.useState(false), 2), expanded = _d[0], setExpanded = _d[1];
    var _e = __read(react_1.useState({
        top: false,
        left: false,
        bottom: false,
        right: false,
    }), 2), dropdownOutside = _e[0], setDropdownOutside = _e[1];
    /** true when dropdown is not expanded after transitions */
    var _f = __read(react_1.useState(true), 2), isHidden = _f[0], setIsHidden = _f[1];
    var _g = __read(react_1.useState(''), 2), dropdownContentClassName = _g[0], setDropdownContentClassName = _g[1]; //set from context child
    var _h = __read(react_1.useState(), 2), ariaHasPopup = _h[0], setAriaHasPopup = _h[1]; //set from context child
    var _j = __read(react_1.useState('dropdown'), 2), contextAriaLabel = _j[0], setContextAriaLabel = _j[1]; //set from context child
    //--- effects ---//
    react_1.useEffect(function () {
        if (props.expanded !== undefined) {
            setExpanded(props.expanded);
        }
    }, [props.expanded]);
    react_1.useEffect(function () {
        onCloseRef.current = props.onClose;
    }, [props.onClose]);
    useOnClickOutside_1.useOnClickOutside(el, function (e) {
        if (expanded) {
            if (props.expanded === undefined)
                setExpanded(false);
            //if (onChangeRef.current) onChangeRef.current(menuRef.current, e)
            if (onCloseRef.current)
                onCloseRef.current(e);
        }
    }, [expanded, props.expanded]);
    useOnTabOutside_1.useOnTabOutside(el, function (e) {
        if (expanded) {
            if (props.expanded === undefined)
                setExpanded(false);
            //if (onChangeRef.current) onChangeRef.current(menuRef.current, e)
            if (onCloseRef.current)
                onCloseRef.current(e);
        }
    }, [expanded, props.expanded]);
    react_1.useEffect(function () {
        if (expanded) {
            //if prop expanded changes to true while disabled or
            //if prop disabled changes to true while expanded
            if (props.disabled) {
                //call onClose to update expanded back to false
                if (onCloseRef.current)
                    onCloseRef.current(null);
            }
        }
    }, [expanded, props.disabled]);
    //--- utility methods ---//
    function isOutsideViewport(el, offset) {
        if (offset === void 0) { offset = { top: 0, right: 0, bottom: 0, left: 0 }; }
        var bounding = el.getBoundingClientRect();
        return {
            top: bounding.top + offset.top < 0,
            left: bounding.left + offset.left < 0,
            bottom: bounding.bottom + offset.bottom >
                (window.innerHeight || document.documentElement.clientHeight),
            right: bounding.right + offset.right >
                (window.innerWidth || document.documentElement.clientWidth),
        };
    }
    var contextSetAriaHasPopup = function (label) {
        setAriaHasPopup(label);
    };
    var contextSetAriaLabel = function (label) {
        setContextAriaLabel(label);
    };
    var contextSetDropdownClassName = function (className) {
        setDropdownContentClassName(className);
    };
    var contextCloseDropdown = function () {
        if (expanded && !props.dismissOnChange)
            return;
        if (props.expanded === undefined) {
            setExpanded(false);
        }
        setTimeout(function () { var _a; return (_a = toggleRef.current) === null || _a === void 0 ? void 0 : _a.focus(); });
        if (expanded) {
            if (onCloseRef.current) {
                onCloseRef.current(null);
            }
        }
    };
    //--- handlers ---//
    var onToggleClick = function (e) {
        if (props.disabled) {
            e.preventDefault();
            return;
        }
        if (props.expanded === undefined) {
            setExpanded(function (prevState) { return !prevState; });
        }
        if (expanded) {
            if (onCloseRef.current)
                onCloseRef.current(e);
        }
        else {
            if (props.onOpen)
                props.onOpen(menuRef.current, e);
        }
    };
    var onTransitionEnter = function (menu) {
        //wait for children to render
        setTimeout(function () {
            setIsHidden(false);
            if (el.current) {
                var out = isOutsideViewport(menu, {
                    top: 15,
                    right: 15,
                    left: 15,
                    bottom: 15,
                });
                setDropdownOutside(out);
            }
        });
    };
    var onTransitionExited = function () {
        setIsHidden(true);
        setDropdownOutside({
            top: false,
            left: false,
            bottom: false,
            right: false,
        });
    };
    return (React.createElement("div", __assign({}, htmlProps, { ref: el, className: classnames_1.default('Dropdown', props.className, dropdownContentClassName, (_b = {},
            _b["Dropdown-" + props.theme] = props.theme,
            _b['Dropdown-expanded'] = expanded,
            _b['Dropdown-disabled'] = props.disabled,
            _b)) }),
        React.createElement(Button_1.Button, __assign({ "aria-label": typeof props.label === 'string'
                ? props.label + " dropdown"
                : contextAriaLabel }, buttonProps, { "aria-expanded": expanded, "aria-controls": menuId.current, "aria-disabled": props.disabled || undefined, "aria-haspopup": ariaHasPopup, ref: toggleRef, className: classnames_1.default('Dropdown_toggle', (_c = buttonProps) === null || _c === void 0 ? void 0 : _c.className), onKeyDown: function (e) {
                //prevent click from firing multiple times in firefox
                if (keyboard_1.isKeyReturn(e) || keyboard_1.isKeySpacebar(e))
                    e.preventDefault();
            }, onKeyUp: function (e) {
                //fire click only on keyUp
                if (keyboard_1.isKeyReturn(e) || keyboard_1.isKeySpacebar(e))
                    onToggleClick(e);
            }, onClick: function (e) {
                onToggleClick(e);
            } }),
            React.createElement("span", { className: 'Dropdown_label' }, props.label),
            props.icon && React.createElement(Icon_1.Icon, { className: "Dropdown_icon", type: props.icon })),
        React.createElement(react_transition_group_1.CSSTransition, { in: expanded && !props.disabled, timeout: { appear: 0, enter: 0, exit: 200 }, classNames: "Dropdown_menu", appear: true, unmountOnExit: props.unmountOnExit, 
            //mountOnEnter
            onEnter: onTransitionEnter, onExited: onTransitionExited },
            React.createElement("div", { ref: menuRef, id: menuId.current, className: classnames_1.default('Dropdown_menu', {
                    'Dropdown_menu-hide': isHidden,
                    'Dropdown_menu-overlay': props.overlay,
                    'Dropdown_menu-top': props.autoAlign && dropdownOutside.top,
                    'Dropdown_menu-right': props.autoAlign && dropdownOutside.right,
                    'Dropdown_menu-bottom': props.autoAlign && dropdownOutside.bottom,
                    'Dropdown_menu-left': props.autoAlign && dropdownOutside.left,
                }) },
                React.createElement(DropdownContext.Provider, { value: {
                        expanded: expanded,
                        isHidden: isHidden,
                        setDropdownClassName: contextSetDropdownClassName,
                        setAriaHasPopup: contextSetAriaHasPopup,
                        setAriaLabel: contextSetAriaLabel,
                        closeDropdown: contextCloseDropdown,
                    } }, props.children)))));
};
DropdownComp.defaultProps = {
    autoAlign: true,
    disabled: false,
    overlay: true,
    dismissOnChange: true,
    unmountOnExit: false,
    theme: 'box',
};
exports.Dropdown = React.memo(DropdownComp);
